import React from 'react';
import {
    BoardKanbanShimmerRoot,
    BoardKanbanShimmerColumn,
    BoardKanbanShimmerBlock,
} from '@/pages/inside/tenant/style';

/** Three-column skeleton shown while GET sprint-by-id loads (milestone/sprint tab change). */
export default function SprintKanbanBoardShimmer() {
    return (
        <BoardKanbanShimmerRoot aria-busy={true} aria-label="Loading sprint board">
            {[0, 1, 2].map((col) => (
                <BoardKanbanShimmerColumn key={col}>
                    <BoardKanbanShimmerBlock $height={20} />
                    <BoardKanbanShimmerBlock $height={52} />
                    <BoardKanbanShimmerBlock $height={68} />
                    <BoardKanbanShimmerBlock $height={44} />
                </BoardKanbanShimmerColumn>
            ))}
        </BoardKanbanShimmerRoot>
    );
}
